"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var theme = (0, _styles.createMuiTheme)({
  // For Underline Color After Click
  palette: {
    primary: {
      main: "rgba(255, 255, 255, 1)"
    }
  },
  // For Underline Hover Color
  overrides: {
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: '#fff',
        borderWidth: 1
      },
      root: {
        color: "rgba(255, 255, 255, 1)",
        "&$focused": {
          "borderColor": "#fff"
        },
        "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
          borderColor: '#fff'
        }
      }
    },
    MuiFormLabel: {
      root: {
        color: "rgba(255, 255, 255, 1)"
      }
    }
  }
});

var InputField = /*#__PURE__*/function (_Component) {
  _inherits(InputField, _Component);

  function InputField() {
    _classCallCheck(this, InputField);

    return _possibleConstructorReturn(this, _getPrototypeOf(InputField).apply(this, arguments));
  }

  _createClass(InputField, [{
    key: "getClassName",

    /**
     * Get class name
     *
     * @returns {string}
     */
    value: function getClassName() {
      var classNames = ['input-group'];

      if (this.props.fullWidth) {
        classNames.push('fulled');
      }

      return classNames.join(' ');
    }
    /**
     * Handle input change
     *
     * @param e
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(e) {
      if (this.props.handler) {
        this.props.handler.handleInputChange(e);
      }
    }
  }, {
    key: "getValidationError",
    value: function getValidationError() {
      var _this = this;

      var messages = [];

      if (this.props.handler) {
        this.props.handler.getErrors().filter(function (x) {
          return x.field === _this.props.name;
        }).forEach(function (error) {
          return messages.push(error.message);
        });
      }

      if (messages.length === 0) {
        return null;
      }

      return _react["default"].createElement("div", {
        className: "validation-message",
        key: this.props.name + '-error'
      }, messages.join("<br/>"));
    }
    /**
     * Render input
     *
     * @returns {XML}
     */

  }, {
    key: "render",
    value: function render() {
      // let className = this.getClassName();
      var validationError = this.getValidationError();
      return _react["default"].createElement("div", {
        className: this.props.className,
        style: {
          position: 'relative'
        },
        id: validationError ? "outlined-error" : ''
      }, _react["default"].createElement(_styles.MuiThemeProvider, {
        theme: this.props.muiTheme ? this.props.muiTheme : theme
      }, _react["default"].createElement(_TextField["default"], _extends({
        error: validationError ? true : false,
        ref: "actualInput",
        variant: "outlined",
        autoComplete: this.props.autoComplete,
        label: this.props.label,
        className: this.props.className,
        type: this.props.type,
        placeholder: this.props.placeholder,
        name: this.props.name,
        inputProps: this.props.inputProps,
        margin: "normal" // InputLabelProps={{
        //   shrink: true,
        // }}
        ,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        value: this.props.value,
        onChange: this.handleInputChange.bind(this)
      }, this.props.materialProps))), validationError);
    }
  }]);

  return InputField;
}(_react.Component);

exports["default"] = InputField;